module.exports = __webpack_public_path__ + "img/titleAtive3.837ccfb.png";